import { useSite } from '../context/SiteContext';

// Announcement set from the admin panel (Notice & payment). Scrolls away with the page.
export default function Notice() {
  const { notice } = useSite();
  if (!notice) return null;

  const external = notice.link && !notice.link.startsWith('#');
  return (
    <div className="border-b border-amber-200 bg-amber-50 text-amber-900" role="note">
      <p className="container-x py-2.5 text-center text-sm sm:text-base">
        <span aria-hidden="true">📢 </span>
        <span className="whitespace-pre-line">{notice.text}</span>
        {notice.link && (
          <a
            href={notice.link}
            {...(external && { target: '_blank', rel: 'noreferrer' })}
            className="ml-2 whitespace-nowrap font-semibold underline underline-offset-2 hover:text-amber-700"
          >
            বিস্তারিত →
          </a>
        )}
      </p>
    </div>
  );
}
